export class Utils {
    static getSceneFromMesh(mesh) {
        return mesh.parent ? this.getSceneFromMesh(mesh.parent) : mesh;
    }
    static isMeshInHierarchyExcludingScene(mesh, parentMeshHierarchy, scene) {
        while (parentMeshHierarchy !== scene) {
            if (mesh === parentMeshHierarchy) {
                return true;
            }
            parentMeshHierarchy = parentMeshHierarchy?.parent ?? null;
        }
        return false;
    }
}
//# sourceMappingURL=Utils.js.map